import { Flex, Form, Input, message, Modal, Typography } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { CustomButton } from '@/components/ui';
import './index.scss';
import { FloatingLabel } from '@/components/ui/FloatingLabel';
import { CustomTextarea } from '@/components/ui/CustomTextarea';
import { useMutation } from '@tanstack/react-query';
import { requestSupport } from '@/api/user';
import { useState } from 'react';

interface Props {
  open: boolean;
  onCancel: () => void;
}

export const RequestHelp = ({ open, onCancel }: Props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const { mutateAsync: supportMessage } = useMutation({
    mutationFn: async (data: { email: string; details?: string }) => {
      return await requestSupport(data);
    },
    onSuccess: () => {
      message.success(
        'Support request sent successfully, we will get back to you soon.',
      );
    },
    onError: (error) => {
      message.error(error.message);
    },
  });

  const onFinish = async (values: any) => {
    setLoading(true);
    await supportMessage(values);
    setLoading(false);
    form.resetFields();
    onCancel();
  };
  return (
    <Modal
      closeIcon={<CloseOutlined />}
      open={open}
      onCancel={onCancel}
      width={460}
      centered
      footer={null}
      className={'request-help-modal'}
      styles={{
        mask: {
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
        },
      }}
    >
      <Flex vertical className={'header'} align={'start'} gap={16}>
        <Typography.Text className={'title'}>
          Request Assistance
        </Typography.Text>

        <Typography.Text className={'description'}>
          Please complete the form below detailing your request and a member of
          our support staff will respond as soon as possible.
        </Typography.Text>
      </Flex>

      <Form layout="vertical" name="basic" onFinish={onFinish} form={form}>
        <FloatingLabel label={'Email'} childrenType="input">
          <Form.Item
            name="email"
            label={'Email'}
            rules={[
              {
                required: true,
                message: 'Please input correct email!',
              },
              {
                type: 'email',
                message: 'Please input a valid email!',
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>
        </FloatingLabel>
        <FloatingLabel label={'Details'} childrenType="textarea">
          <Form.Item
            name={'details'}
            label={'Details'}
            rules={[{ required: true, message: 'Please input your details!' }]}
          >
            <CustomTextarea />
          </Form.Item>
        </FloatingLabel>
      </Form>

      <Flex vertical gap={12}>
        <CustomButton
          onClick={() => form.submit()}
          type={'primary'}
          text={'SUBMIT'}
          disabled={loading}
        />

        <CustomButton type={'default'} onClick={onCancel} text={'CANCEL'} />
      </Flex>
    </Modal>
  );
};
